import firebase from 'firebase/app'
require('firebase/auth')
import 'firebase/firestore'
import firebaseConfig from './firebaseConfig'
import store from '../store'

const firebaseApp = firebase.initializeApp(firebaseConfig)

// Listen to auth user state change
// => trigger fetchUser() in store which gets and sets user from firebase/firestore into store.state
// => => Meld aan log dat gebruiker is ingelogd
firebase.auth().onAuthStateChanged(user => {
  store.dispatch('fetchUser', user)
  if (user) {
    // console.log('User is logged in');
    store.dispatch('fetchTekenaren')
    store.dispatch('fetchOpdrachten')
    store.dispatch('fetchTodos')
    store.dispatch('fetchStatus')
  }
})

export default firebaseApp.firestore()
